export const dbOptions = [{
  dbName: "MySql",
  options: [{
    inputName: "host",
    labelName: "Host",
    validations: {
      "required": true,
      "format": ""
    }
  },
  {
    inputName: "port",
    labelName: "Port",
    validations: {
      "required": true,
      "format": ""
    }
  },
  {
    inputName: "username",
    labelName: "Username",
    validations: {
      "required": true,
      "format": ""
    }
  },
  {
    inputName: "password",
    inputType: "password",
    labelName: "Password",
    validations: {
      "required": true,
      "format": ""
    }
  },
  {
    inputName: "database",
    labelName: "Database",
    validations: {
      "required": true,
      "format": ""
    }
  }
  ]
}, {
  dbName: "MongoDB",
  options: [{
    inputName: "host",
    labelName: "Host",
    validations: {
      "required": true,
      "format": ""
    }
  },
  {
    inputName: "port",
    labelName: "Port",
    validations: {
      "required": true,
      "format": ""
    }
  },
  {
    inputName: "username",
    labelName: "Username",
    validations: {
      "required": false,
      "format": ""
    }
  },
  {
    inputName: "password",
    inputType: "password",
    labelName: "Password",
    validations: {
      "required": false,
      "format": ""
    }
  },
  {
    inputName: "database",
    labelName: "Database",
    validations: {
      "required": true,
      "format": ""
    }
  }
  ]
},
{
  dbName: "SQLite",
  options: [{
    inputName: "file-upload",
    inputType: "file",
    labelName: "File Upload",
    validations: {
      "required": true,
      "format": ""
    }
  }]
}

];

export const successResponse = [{
  name: "table",
  contents: [{
    name: "table 1"
  }, {
    name: "table 2"
  }]
},
{
  name: "functions",
  contents: [{
    name: "function 1"
  }, {
    name: "function 2"
  }]
},
{
  name: "container",
  contents: [{
    name: "container 1",
    contents: ["item 1", "item 2"]
  }]
}
]